// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.transfers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}
.transfers-header .search-container {
  flex: 1 1;
  min-width: 300px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.model-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.model-details .model-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.model-details .model-detail-item .model-name {
  color: #666;
  font-weight: 500;
}
.model-details .model-detail-item .model-count {
  color: #00b4f3;
  font-weight: 600;
}

.stock-transfer-view .transfer-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 24px;
}
.stock-transfer-view .transfer-header .transfer-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.stock-transfer-view .transfer-header .transfer-info h3 {
  margin: 0;
  font-size: 24px;
}
.stock-transfer-view .transfer-header .transfer-date {
  text-align: right;
}
.stock-transfer-view .transfer-header .transfer-date small {
  color: #666;
  font-size: 12px;
}
.stock-transfer-view .transfer-header .transfer-date p {
  margin: 4px 0 0;
  font-weight: 500;
}
.stock-transfer-view .status-actions {
  padding: 16px;
  background: #fff3cd;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  gap: 12px;
}
.stock-transfer-view .transfer-details {
  margin-bottom: 32px;
}
.stock-transfer-view .transfer-details .detail-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}
.stock-transfer-view .transfer-details .detail-row .detail-column {
  flex: 1 1;
}
.stock-transfer-view .transfer-details .detail-row .detail-column.full-width {
  flex: 1 1 100%;
}
.stock-transfer-view .transfer-details .detail-row .detail-column h4 {
  margin: 0 0 12px;
  font-size: 14px;
  color: #666;
  text-transform: uppercase;
  font-weight: 600;
}
.stock-transfer-view .transfer-details .detail-row .detail-column .entity-card {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.stock-transfer-view .transfer-details .detail-row .detail-column .entity-card strong {
  font-size: 16px;
  display: block;
  margin-bottom: 4px;
}
.stock-transfer-view .transfer-details .detail-row .detail-column .entity-card .entity-type {
  color: #666;
  font-size: 12px;
  margin: 0 0 8px;
}
.stock-transfer-view .transfer-details .detail-row .detail-column .entity-card .entity-detail {
  color: #666;
  font-size: 14px;
  margin: 4px 0 0;
}
.stock-transfer-view .transfer-details .detail-row .detail-column > p {
  margin: 0;
  color: #333;
}
.stock-transfer-view .transfer-items {
  margin-bottom: 32px;
}
.stock-transfer-view .transfer-items h4 {
  margin: 0 0 16px;
  font-size: 18px;
}
.stock-transfer-view .transfer-items .items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.stock-transfer-view .transfer-items .items-list .item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-info svg {
  color: #0066cc;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-info strong {
  display: block;
  margin-bottom: 4px;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-info p {
  margin: 0;
  font-size: 14px;
  color: #666;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-info p code {
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
}
.stock-transfer-view .transfer-items .items-list .item-card .item-quantity span {
  font-weight: 600;
  color: #0066cc;
}
.stock-transfer-view .transfer-items .empty-state.small {
  padding: 30px 20px;
}
.stock-transfer-view .transfer-items .empty-state.small svg {
  opacity: 0.3;
}
.stock-transfer-view .transfer-items .empty-state.small p {
  font-size: 14px;
}
.stock-transfer-view .transfer-timeline h4 {
  margin: 0 0 16px;
  font-size: 18px;
}
.stock-transfer-view .transfer-timeline .timeline {
  position: relative;
  padding-left: 32px;
}
.stock-transfer-view .transfer-timeline .timeline::before {
  content: "";
  position: absolute;
  left: 7px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: #e9ecef;
}
.stock-transfer-view .transfer-timeline .timeline .timeline-item {
  position: relative;
  margin-bottom: 16px;
}
.stock-transfer-view .transfer-timeline .timeline .timeline-item:last-child {
  margin-bottom: 0;
}
.stock-transfer-view .transfer-timeline .timeline .timeline-item .timeline-marker {
  position: absolute;
  left: -28px;
  top: 4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #0066cc;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px #e9ecef;
}
.stock-transfer-view .transfer-timeline .timeline .timeline-item .timeline-content strong {
  display: block;
  margin-bottom: 4px;
}
.stock-transfer-view .transfer-timeline .timeline .timeline-item .timeline-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

/* Models Modal Styles */
.models-summary-simple {
  display: flex;
  gap: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.summary-label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}

.summary-value.text-success {
  color: #28a745;
}

.model-item-simple {
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
}

.model-item-simple:last-child {
  border-bottom: none;
}

.model-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.model-name-simple {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
}

.empty-models-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.empty-icon {
  color: #cbd5e0;
  margin-bottom: 0.5rem;
}

.empty-text {
  font-size: 14px;
  color: #6c757d;
}

.delivery-info-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 12px);
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
}
.delivery-info-card__header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.delivery-info-card__avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.delivery-info-card__content {
  flex: 1 1;
  min-width: 0;
}
.delivery-info-card__content h3 {
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--m-text, #333);
}
.delivery-info-card__content .delivery-info-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
}
.delivery-info-card__content .delivery-info-card__meta .meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--m-text-light, #666);
  padding: 4px 10px;
  background: var(--m-background-subtle-primary, #f0f0f0);
  border-radius: 6px;
}
.delivery-info-card__content .delivery-info-card__meta .meta-item svg {
  color: var(--m-primary, #007bff);
}
.delivery-info-card__stats {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}
.delivery-info-card__stats .stat-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--m-background-subtle-primary, #f0f0f0);
  border-radius: 8px;
  border: 1px solid var(--m-primary-subtle, #e0e0e0);
  min-width: 100px;
}
.delivery-info-card__stats .stat-badge svg {
  color: var(--m-primary, #007bff);
  flex-shrink: 0;
}
.delivery-info-card__stats .stat-badge .stat-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--m-text, #333);
  line-height: 1.2;
}
.delivery-info-card__stats .stat-badge .stat-label {
  font-size: 11px;
  color: var(--m-text-light, #666);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.delivery-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.delivery-detail-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 12px);
  padding: 20px;
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  transition: all 0.2s ease;
}
.delivery-detail-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: var(--m-primary, #007bff);
}
.delivery-detail-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.delivery-detail-card__header svg {
  color: var(--m-primary, #007bff);
  flex-shrink: 0;
}
.delivery-detail-card__header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text, #333);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.delivery-detail-card__body strong {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: var(--m-text, #333);
  margin-bottom: 6px;
}
.delivery-detail-card__body p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--m-text-light, #666);
}
.delivery-detail-card__body p.small {
  font-size: 12px;
}

.delivery-notes-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 12px);
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
}
.delivery-notes-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.delivery-notes-card__header svg {
  color: var(--m-primary, #007bff);
  flex-shrink: 0;
}
.delivery-notes-card__header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text, #333);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.delivery-notes-card__body p {
  margin: 0;
  font-size: 14px;
  color: var(--m-text, #333);
  line-height: 1.6;
}

.delivery-section {
  margin-bottom: 32px;
}
.delivery-section__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--m-subtle, #f0f0f0);
}
.delivery-section__header svg {
  color: var(--m-primary, #007bff);
  flex-shrink: 0;
}
.delivery-section__header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--m-text, #333);
  flex: 1 1;
}

.delivery-batches-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.delivery-batch-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 12px);
  padding: 16px;
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  transition: all 0.2s ease;
}
.delivery-batch-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: var(--m-primary, #007bff);
}
.delivery-batch-card__header {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.delivery-batch-card__header .batch-number {
  display: inline-block;
  padding: 4px 12px;
  background: var(--m-background-subtle-primary, #e3f2fd);
  color: var(--m-primary, #007bff);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.delivery-batch-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.delivery-batch-card__body .batch-info-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.delivery-batch-card__body .batch-info-item svg {
  color: var(--m-text-light, #999);
  margin-top: 2px;
  flex-shrink: 0;
}
.delivery-batch-card__body .batch-info-item div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.delivery-batch-card__body .batch-info-item .batch-info-label {
  font-size: 11px;
  color: var(--m-text-light, #666);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}
.delivery-batch-card__body .batch-info-item .batch-info-value {
  font-size: 14px;
  color: var(--m-text, #333);
  font-weight: 500;
}

.delivery-models-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.delivery-model-card {
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e0e0e0);
  border-radius: var(--m-border-radius-md, 12px);
  padding: 20px;
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  transition: all 0.2s ease;
}
.delivery-model-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: var(--m-primary, #007bff);
}
.delivery-model-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--m-subtle, #f0f0f0);
}
.delivery-model-card__header .delivery-model-card__info {
  flex: 1 1;
  min-width: 0;
}
.delivery-model-card__header .delivery-model-card__info h5 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--m-text, #333);
}
.delivery-model-card__header .delivery-model-card__info p {
  margin: 0;
  font-size: 12px;
  color: var(--m-text-light, #666);
}
.delivery-model-card__devices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.delivery-model-card__devices .delivery-device-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--m-background-subtle-primary, #f8f9fa);
  border-radius: 6px;
  font-size: 13px;
  color: var(--m-text, #333);
}
.delivery-model-card__devices .delivery-device-item svg {
  color: var(--m-text-light, #999);
  flex-shrink: 0;
}
.delivery-model-card__devices .delivery-device-item strong {
  font-weight: 600;
  color: var(--m-text, #333);
  font-family: monospace;
}

.delivery-timeline {
  position: relative;
  padding-left: 32px;
}
.delivery-timeline::before {
  content: "";
  position: absolute;
  left: 7px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: var(--m-border-card-file, #e0e0e0);
}

.delivery-timeline-item {
  position: relative;
  margin-bottom: 20px;
}
.delivery-timeline-item:last-child {
  margin-bottom: 0;
}
.delivery-timeline-item .delivery-timeline-marker {
  position: absolute;
  left: -28px;
  top: 4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--m-primary, #007bff);
  border: 3px solid var(--m-card-background-color, #fff);
  box-shadow: 0 0 0 2px var(--m-border-card-file, #e0e0e0);
  z-index: 1;
}
.delivery-timeline-item .delivery-timeline-content strong {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text, #333);
}
.delivery-timeline-item .delivery-timeline-content p {
  margin: 0;
  color: var(--m-text-light, #666);
  font-size: 13px;
}

@media (max-width: 768px) {
  .delivery-info-card__header {
    flex-direction: column;
    align-items: flex-start;
  }
  .delivery-info-card__stats {
    width: 100%;
    justify-content: space-between;
  }
  .delivery-details-grid {
    grid-template-columns: 1fr;
  }
  .delivery-batches-list,
  .delivery-models-list {
    grid-template-columns: 1fr;
  }
}
/* Filters block (Deliveries list — same pattern as Devices / Device Sales) */
.top-filters {
  width: 100%;
}
@media (max-width: 768px) {
  .top-filters > .d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.75rem;
    width: 100%;
  }
  .top-filters > .d-flex.justify-content-between .btn {
    width: 100%;
  }
}

.list-filters__panel {
  padding: 0;
  background: transparent;
  border-top: none;
  width: 100%;
}

.list-filters__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  align-items: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__grid {
    flex-direction: column;
    align-items: stretch;
  }
}

.list-filters__field {
  min-width: 0;
  flex: 1 1 200px;
  max-width: 100%;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .list-filters__field {
    flex: 1 1 100%;
    min-width: 100%;
  }
}

.list-filters__control {
  width: 100%;
  background: #fff;
  border: 1px solid #e2e5e8;
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.list-filters__control .dropdown {
  width: 100%;
}
.list-filters__control .dropdown__trigger {
  width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: none;
}
.list-filters__control .m-select {
  margin-bottom: 0;
}
.list-filters__control .m-select-selected {
  border: none !important;
  box-shadow: none !important;
}
.list-filters__control:hover {
  border-color: #cfd8e3;
}
.list-filters__control:focus-within {
  border-color: rgba(13, 110, 253, 0.45);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}

.list-filters__footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__footer {
    justify-content: stretch;
  }
  .list-filters__footer .btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Deliveries/StockTransfers.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAEF;AAAE;EACE,SAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AACF;AACE;EACE,kCAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;;AAIA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAFF;AAIE;EACE,gBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,aAAA;EACA,QAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAHJ;AAKI;EACE,WAAA;EACA,gBAAA;AAHN;AAMI;EACE,cAAA;EACA,gBAAA;AAJN;;AAWE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AARJ;AAUI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AARN;AAUM;EACE,SAAA;EACA,eAAA;AARR;AAYI;EACE,iBAAA;AAVN;AAYM;EACE,WAAA;EACA,eAAA;AAVR;AAaM;EACE,eAAA;EACA,gBAAA;AAXR;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAfN;AAiBM;EACE,SAAA;AAfR;AAiBQ;EACE,cAAA;AAfV;AAkBQ;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AAhBV;AAmBQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAjBV;AAmBU;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAjBZ;AAoBU;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAlBZ;AAqBU;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAnBZ;AAuBQ;EACE,SAAA;EACA,WAAA;AArBV;AA2BE;EACE,mBAAA;AAzBJ;AA2BI;EACE,gBAAA;EACA,eAAA;AAzBN;AA4BI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1BN;AA4BM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA1BR;AA4BQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1BV;AA4BU;EACE,cAAA;AA1BZ;AA6BU;EACE,cAAA;EACA,kBAAA;AA3BZ;AA8BU;EACE,SAAA;EACA,eAAA;EACA,WAAA;AA5BZ;AA8BY;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AA5Bd;AAkCU;EACE,gBAAA;EACA,cAAA;AAhCZ;AAsCI;EACE,kBAAA;AApCN;AAsCM;EACE,YAAA;AApCR;AAuCM;EACE,eAAA;AArCR;AA2CI;EACE,gBAAA;EACA,eAAA;AAzCN;AA4CI;EACE,kBAAA;EACA,kBAAA;AA1CN;AA4CM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AA1CR;AA6CM;EACE,kBAAA;EACA,mBAAA;AA3CR;AA6CQ;EACE,gBAAA;AA3CV;AA8CQ;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;AA5CV;AAgDU;EACE,cAAA;EACA,kBAAA;AA9CZ;AAiDU;EACE,SAAA;EACA,WAAA;EACA,eAAA;AA/CZ;;AAuDA,wBAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AApDF;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AApDF;;AAuDA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApDF;;AAuDA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApDF;;AAuDA;EACE,cAAA;AApDF;;AAuDA;EACE,kBAAA;EACA,gCAAA;AApDF;;AAuDA;EACE,mBAAA;AApDF;;AAuDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApDF;;AAuDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AApDF;;AAuDA;EACE,cAAA;EACA,qBAAA;AApDF;;AAuDA;EACE,eAAA;EACA,cAAA;AApDF;;AAwDA;EACE,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,kEAAA;AArDF;AAuDE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AArDJ;AAwDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAtDJ;AAyDE;EACE,SAAA;EACA,YAAA;AAvDJ;AAyDI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAvDN;AA0DI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AAxDN;AA0DM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;AAxDR;AA0DQ;EACE,gCAAA;AAxDV;AA8DE;EACE,aAAA;EACA,SAAA;EACA,cAAA;AA5DJ;AA8DI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uDAAA;EACA,kBAAA;EACA,kDAAA;EACA,gBAAA;AA5DN;AA8DM;EACE,gCAAA;EACA,cAAA;AA5DR;AA+DM;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AA7DR;AAgEM;EACE,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA9DR;;AAoEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAjEF;;AAoEA;EACE,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,aAAA;EACA,kEAAA;EACA,yBAAA;AAjEF;AAmEE;EACE,0CAAA;EACA,uCAAA;AAjEJ;AAoEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAlEJ;AAoEI;EACE,gCAAA;EACA,cAAA;AAlEN;AAqEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;AAnEN;AAwEI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAtEN;AAyEI;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AAvEN;AAyEM;EACE,eAAA;AAvER;;AA6EA;EACE,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,kEAAA;AA1EF;AA4EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AA1EJ;AA4EI;EACE,gCAAA;EACA,cAAA;AA1EN;AA6EI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;AA3EN;AAgFI;EACE,SAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AA9EN;;AAmFA;EACE,mBAAA;AAhFF;AAkFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAhFJ;AAkFI;EACE,gCAAA;EACA,cAAA;AAhFN;AAmFI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAjFN;;AAsFA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAnFF;;AAsFA;EACE,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,aAAA;EACA,kEAAA;EACA,yBAAA;AAnFF;AAqFE;EACE,0CAAA;EACA,uCAAA;AAnFJ;AAsFE;EACE,mBAAA;EACA,oBAAA;EACA,iDAAA;AApFJ;AAsFI;EACE,qBAAA;EACA,iBAAA;EACA,uDAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AApFN;AAwFE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtFJ;AAwFI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAtFN;AAwFM;EACE,gCAAA;EACA,eAAA;EACA,cAAA;AAtFR;AAyFM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAvFR;AA0FM;EACE,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAxFR;AA2FM;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;AAzFR;;AA+FA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA5FF;;AA+FA;EACE,gDAAA;EACA,oDAAA;EACA,8CAAA;EACA,aAAA;EACA,kEAAA;EACA,yBAAA;AA5FF;AA8FE;EACE,0CAAA;EACA,uCAAA;AA5FJ;AA+FE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AA7FJ;AA+FI;EACE,SAAA;EACA,YAAA;AA7FN;AA+FM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AA7FR;AAgGM;EACE,SAAA;EACA,eAAA;EACA,gCAAA;AA9FR;AAmGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjGJ;AAmGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAjGN;AAmGM;EACE,gCAAA;EACA,cAAA;AAjGR;AAoGM;EACE,gBAAA;EACA,0BAAA;EACA,sBAAA;AAlGR;;AAwGA;EACE,kBAAA;EACA,kBAAA;AArGF;AAuGE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,8CAAA;AArGJ;;AAyGA;EACE,kBAAA;EACA,mBAAA;AAtGF;AAwGE;EACE,gBAAA;AAtGJ;AAyGE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,sDAAA;EACA,wDAAA;EACA,UAAA;AAvGJ;AA2GI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAzGN;AA4GI;EACE,SAAA;EACA,gCAAA;EACA,eAAA;AA1GN;;AA+GA;EAEI;IACE,sBAAA;IACA,uBAAA;EA7GJ;EAgHE;IACE,WAAA;IACA,8BAAA;EA9GJ;EAkHA;IACE,0BAAA;EAhHF;EAmHA;;IAEE,0BAAA;EAjHF;AACF;AAoHA,6EAAA;AACA;EACE,WAAA;AAlHF;AAoHE;EACE;IACE,sBAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;EAlHJ;EAoHI;IACE,WAAA;EAlHN;AACF;;AAuHA;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AApHF;;AAuHA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AApHF;AAsHE;EAPF;IAQI,sBAAA;IACA,oBAAA;EAnHF;AACF;;AAsHA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAnHF;AAqHE;EANF;IAOI,cAAA;IACA,eAAA;EAlHF;AACF;;AAqHA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wDACE;AAnHJ;AAsHE;EACE,WAAA;AApHJ;AAuHE;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AArHJ;AAwHE;EACE,gBAAA;AAtHJ;AAyHE;EACE,uBAAA;EACA,2BAAA;AAvHJ;AA0HE;EACE,qBAAA;AAxHJ;AA2HE;EACE,sCAAA;EACA,8CAAA;AAzHJ;;AA6HA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AA1HF;AA4HE;EARF;IASI,wBAAA;EAzHF;EA2HE;IACE,WAAA;EAzHJ;AACF","sourcesContent":[".transfers-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n  flex-wrap: wrap;\n\n  .search-container {\n    flex: 1;\n    min-width: 300px;\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.model-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  .model-detail-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n\n    .model-name {\n      color: #666;\n      font-weight: 500;\n    }\n\n    .model-count {\n      color: #00b4f3;\n      font-weight: 600;\n    }\n  }\n}\n\n// View Stock Transfer Styles\n.stock-transfer-view {\n  .transfer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    margin-bottom: 24px;\n\n    .transfer-info {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      h3 {\n        margin: 0;\n        font-size: 24px;\n      }\n    }\n\n    .transfer-date {\n      text-align: right;\n\n      small {\n        color: #666;\n        font-size: 12px;\n      }\n\n      p {\n        margin: 4px 0 0;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .status-actions {\n    padding: 16px;\n    background: #fff3cd;\n    border-radius: 8px;\n    margin-bottom: 24px;\n    display: flex;\n    gap: 12px;\n  }\n\n  .transfer-details {\n    margin-bottom: 32px;\n\n    .detail-row {\n      display: flex;\n      gap: 24px;\n      margin-bottom: 24px;\n\n      .detail-column {\n        flex: 1;\n\n        &.full-width {\n          flex: 1 1 100%;\n        }\n\n        h4 {\n          margin: 0 0 12px;\n          font-size: 14px;\n          color: #666;\n          text-transform: uppercase;\n          font-weight: 600;\n        }\n\n        .entity-card {\n          padding: 16px;\n          background: #f8f9fa;\n          border-radius: 8px;\n          border: 1px solid #e9ecef;\n\n          strong {\n            font-size: 16px;\n            display: block;\n            margin-bottom: 4px;\n          }\n\n          .entity-type {\n            color: #666;\n            font-size: 12px;\n            margin: 0 0 8px;\n          }\n\n          .entity-detail {\n            color: #666;\n            font-size: 14px;\n            margin: 4px 0 0;\n          }\n        }\n\n        > p {\n          margin: 0;\n          color: #333;\n        }\n      }\n    }\n  }\n\n  .transfer-items {\n    margin-bottom: 32px;\n\n    h4 {\n      margin: 0 0 16px;\n      font-size: 18px;\n    }\n\n    .items-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n\n      .item-card {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        border: 1px solid #e9ecef;\n\n        .item-info {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          svg {\n            color: #0066cc;\n          }\n\n          strong {\n            display: block;\n            margin-bottom: 4px;\n          }\n\n          p {\n            margin: 0;\n            font-size: 14px;\n            color: #666;\n\n            code {\n              background: #e9ecef;\n              padding: 2px 6px;\n              border-radius: 4px;\n              font-family: monospace;\n            }\n          }\n        }\n\n        .item-quantity {\n          span {\n            font-weight: 600;\n            color: #0066cc;\n          }\n        }\n      }\n    }\n\n    .empty-state.small {\n      padding: 30px 20px;\n\n      svg {\n        opacity: 0.3;\n      }\n\n      p {\n        font-size: 14px;\n      }\n    }\n  }\n\n  .transfer-timeline {\n    h4 {\n      margin: 0 0 16px;\n      font-size: 18px;\n    }\n\n    .timeline {\n      position: relative;\n      padding-left: 32px;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 7px;\n        top: 8px;\n        bottom: 8px;\n        width: 2px;\n        background: #e9ecef;\n      }\n\n      .timeline-item {\n        position: relative;\n        margin-bottom: 16px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .timeline-marker {\n          position: absolute;\n          left: -28px;\n          top: 4px;\n          width: 16px;\n          height: 16px;\n          border-radius: 50%;\n          background: #0066cc;\n          border: 3px solid #fff;\n          box-shadow: 0 0 0 1px #e9ecef;\n        }\n\n        .timeline-content {\n          strong {\n            display: block;\n            margin-bottom: 4px;\n          }\n\n          p {\n            margin: 0;\n            color: #666;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Models Modal Styles */\n.models-summary-simple {\n  display: flex;\n  gap: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.summary-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.summary-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.summary-value.text-success {\n  color: #28a745;\n}\n\n.model-item-simple {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.model-item-simple:last-child {\n  border-bottom: none;\n}\n\n.model-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.model-name-simple {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1a202c;\n}\n\n.empty-models-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.empty-icon {\n  color: #cbd5e0;\n  margin-bottom: 0.5rem;\n}\n\n.empty-text {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n// View Delivery Styles - Improved Design\n.delivery-info-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 12px);\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n  }\n\n  &__avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: var(--m-background-subtle-primary, #e3f2fd);\n    color: var(--m-primary, #007bff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n\n    h3 {\n      margin: 0 0 12px 0;\n      font-size: 20px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n    }\n\n    .delivery-info-card__meta {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 16px;\n      margin-top: 8px;\n\n      .meta-item {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 13px;\n        color: var(--m-text-light, #666);\n        padding: 4px 10px;\n        background: var(--m-background-subtle-primary, #f0f0f0);\n        border-radius: 6px;\n\n        svg {\n          color: var(--m-primary, #007bff);\n        }\n      }\n    }\n  }\n\n  &__stats {\n    display: flex;\n    gap: 12px;\n    flex-shrink: 0;\n\n    .stat-badge {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 12px 16px;\n      background: var(--m-background-subtle-primary, #f0f0f0);\n      border-radius: 8px;\n      border: 1px solid var(--m-primary-subtle, #e0e0e0);\n      min-width: 100px;\n\n      svg {\n        color: var(--m-primary, #007bff);\n        flex-shrink: 0;\n      }\n\n      .stat-value {\n        font-size: 18px;\n        font-weight: 700;\n        color: var(--m-text, #333);\n        line-height: 1.2;\n      }\n\n      .stat-label {\n        font-size: 11px;\n        color: var(--m-text-light, #666);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n.delivery-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.delivery-detail-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 12px);\n  padding: 20px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-color: var(--m-primary, #007bff);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n\n    svg {\n      color: var(--m-primary, #007bff);\n      flex-shrink: 0;\n    }\n\n    h4 {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  &__body {\n    strong {\n      display: block;\n      font-size: 16px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n      margin-bottom: 6px;\n    }\n\n    p {\n      margin: 4px 0;\n      font-size: 14px;\n      color: var(--m-text-light, #666);\n\n      &.small {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.delivery-notes-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 12px);\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n\n    svg {\n      color: var(--m-primary, #007bff);\n      flex-shrink: 0;\n    }\n\n    h4 {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  &__body {\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: var(--m-text, #333);\n      line-height: 1.6;\n    }\n  }\n}\n\n.delivery-section {\n  margin-bottom: 32px;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid var(--m-subtle, #f0f0f0);\n\n    svg {\n      color: var(--m-primary, #007bff);\n      flex-shrink: 0;\n    }\n\n    h4 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n      flex: 1;\n    }\n  }\n}\n\n.delivery-batches-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.delivery-batch-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 12px);\n  padding: 16px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-color: var(--m-primary, #007bff);\n  }\n\n  &__header {\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n\n    .batch-number {\n      display: inline-block;\n      padding: 4px 12px;\n      background: var(--m-background-subtle-primary, #e3f2fd);\n      color: var(--m-primary, #007bff);\n      border-radius: 6px;\n      font-size: 12px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    .batch-info-item {\n      display: flex;\n      align-items: flex-start;\n      gap: 10px;\n\n      svg {\n        color: var(--m-text-light, #999);\n        margin-top: 2px;\n        flex-shrink: 0;\n      }\n\n      div {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n      }\n\n      .batch-info-label {\n        font-size: 11px;\n        color: var(--m-text-light, #666);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        font-weight: 500;\n      }\n\n      .batch-info-value {\n        font-size: 14px;\n        color: var(--m-text, #333);\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n.delivery-models-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.delivery-model-card {\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border-card-file, #e0e0e0);\n  border-radius: var(--m-border-radius-md, 12px);\n  padding: 20px;\n  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-color: var(--m-primary, #007bff);\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--m-subtle, #f0f0f0);\n\n    .delivery-model-card__info {\n      flex: 1;\n      min-width: 0;\n\n      h5 {\n        margin: 0 0 4px 0;\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--m-text, #333);\n      }\n\n      p {\n        margin: 0;\n        font-size: 12px;\n        color: var(--m-text-light, #666);\n      }\n    }\n  }\n\n  &__devices {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .delivery-device-item {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 8px 12px;\n      background: var(--m-background-subtle-primary, #f8f9fa);\n      border-radius: 6px;\n      font-size: 13px;\n      color: var(--m-text, #333);\n\n      svg {\n        color: var(--m-text-light, #999);\n        flex-shrink: 0;\n      }\n\n      strong {\n        font-weight: 600;\n        color: var(--m-text, #333);\n        font-family: monospace;\n      }\n    }\n  }\n}\n\n.delivery-timeline {\n  position: relative;\n  padding-left: 32px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 7px;\n    top: 8px;\n    bottom: 8px;\n    width: 2px;\n    background: var(--m-border-card-file, #e0e0e0);\n  }\n}\n\n.delivery-timeline-item {\n  position: relative;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  .delivery-timeline-marker {\n    position: absolute;\n    left: -28px;\n    top: 4px;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: var(--m-primary, #007bff);\n    border: 3px solid var(--m-card-background-color, #fff);\n    box-shadow: 0 0 0 2px var(--m-border-card-file, #e0e0e0);\n    z-index: 1;\n  }\n\n  .delivery-timeline-content {\n    strong {\n      display: block;\n      margin-bottom: 4px;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--m-text, #333);\n    }\n\n    p {\n      margin: 0;\n      color: var(--m-text-light, #666);\n      font-size: 13px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .delivery-info-card {\n    &__header {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    &__stats {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n\n  .delivery-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .delivery-batches-list,\n  .delivery-models-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Filters block (Deliveries list — same pattern as Devices / Device Sales) */\n.top-filters {\n  width: 100%;\n\n  @media (max-width: 768px) {\n    > .d-flex.justify-content-between {\n      flex-direction: column;\n      align-items: stretch !important;\n      gap: 0.75rem;\n      width: 100%;\n\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.list-filters__panel {\n  padding: 0;\n  background: transparent;\n  border-top: none;\n  width: 100%;\n}\n\n.list-filters__grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  align-items: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.list-filters__field {\n  min-width: 0;\n  flex: 1 1 200px;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  @media (max-width: 768px) {\n    flex: 1 1 100%;\n    min-width: 100%;\n  }\n}\n\n.list-filters__control {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #e2e5e8;\n  border-radius: 8px;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  .dropdown {\n    width: 100%;\n  }\n\n  .dropdown__trigger {\n    width: 100%;\n    box-sizing: border-box;\n    border: none;\n    box-shadow: none;\n  }\n\n  .m-select {\n    margin-bottom: 0;\n  }\n\n  .m-select-selected {\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  &:hover {\n    border-color: #cfd8e3;\n  }\n\n  &:focus-within {\n    border-color: rgba(13, 110, 253, 0.45);\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);\n  }\n}\n\n.list-filters__footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    justify-content: stretch;\n\n    .btn {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
